export default __webpack_public_path__ + "static/delay-pro-gui-0113fd0907a10748759ad719873d9c55.png";